import { useState, useRef, useEffect } from "react";
// models
import { PublicacionesModel, initialValuesPublicacionesmodel } from "../models/Publicaciones/Publicaciones";
// api services
import apiJurados from "../api/Jurados/api-jurados";
// notifications
import { Notificaciones } from "../config/notificaciones_new";
// route
import { useNavigate, useParams } from "react-router";
// redux
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../redux/reducers";

import { juradoEditar, juradoAtras, menuJuradoAction } from '../redux/actions/juradosAction';
import { openNotification } from "../utils/saveFile";
import DocumentosService from "../api/Documentos/api-documentos";

export const usePublicaciones = () => {
  // redux

  const { menuJurado } = useSelector((state: RootState) => state.jurado);
  const idJurado =  localStorage.getItem('idJurado')

  // route
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // state
  const [publicacion, setPublicacion] = useState<PublicacionesModel>(initialValuesPublicacionesmodel);
  const [publicaciones, setPublicaciones] = useState<Array<PublicacionesModel>>([]);
  const [modaleditar, setModaleditar] = useState<boolean>(false);
  const [modaleliminar, setModaleliminar] = useState<boolean>(false);
  const [nombrepublicacion, setNombrepublicacion] = useState<string>("");
  const [indexpublicacion, setIndexpublicacion] = useState<number>(0);
  const [modalVisualizarDocumento, setModalVisualizarDocumento] = useState(false);
  const [documentoVisualizar, setDocumentoVisualizar] = useState("");
  // ref
  const fileInputRef = useRef<any>();
  const { estadoFormulario } = useParams();

  useEffect(() => {
    
      cargarPublicaciones();
    
  }, []);

  // functions
  const prevScreen = () => {
    dispatch(juradoAtras(true));
    return navigate("/usuario/Reconocimientos")
  }
  const cargarPublicaciones = async () => {
    const {data} = await apiJurados.obtenerPublicaciones(idJurado);
    if(data != undefined){
      return setPublicaciones(data);
    }else{
      return setPublicaciones([]);
    }
    
  };

  const agregarFila = () => {
    if (publicacion.documento === "") {
      return openNotification({titulo: "Error", descripcion: "Falta adjuntar archivo", placement: "bottomRight"});
    }


    setPublicaciones([...publicaciones, publicacion]);
    return setPublicacion(initialValuesPublicacionesmodel);
  };
  const limpiarCampos = () => {
    return setPublicacion(initialValuesPublicacionesmodel);
  };
  const guardarCamposModal = () => {
    let infoupdate = [...publicaciones];
    infoupdate[indexpublicacion] = publicacion;
    setPublicaciones(infoupdate);
    setPublicacion(initialValuesPublicacionesmodel);
    return setModaleditar(false);
  };
  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      if (e.target.files[0].type === "application/pdf") {
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        return setPublicacion({ ...publicacion, documento: data.data });
      }
      openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos PDF",
        placement: "bottomRight",
      });
      return setPublicacion({ ...publicacion, documento: "" });
    }
  };
  const guardarArchivoeditar = async (e: any, reconocimientossend: any) => {
    if (e.target.files.length > 0) {
      if (e.target.files[0].type === "application/pdf") {
        if (e.target.files[0].size > 5000000) {
          return openNotification({
            titulo: "Error",
            descripcion: "Solo se permiten archivos menores a 5MB",
            placement: "bottomRight",
          });
        }
        const formData = new FormData();
        formData.append("archivo", e.target.files[0]);
        const data = await DocumentosService.guardarArchivo(formData);
        let infoupdate = [...reconocimientossend];
        infoupdate[indexpublicacion].documento = data.data;
        return setPublicaciones(infoupdate);
      }
    }
    openNotification({
      titulo: "Error",
      descripcion: "Solo se permiten archivos PDF",
      placement: "bottomRight",
    });
  };
  const eliminarFila = (indexpub: number) => {
    let infoupdate = [...publicaciones];
    infoupdate = infoupdate.filter((data: any, index: number) => index !== indexpub);
    setPublicaciones(infoupdate);
    return setModaleliminar(false);
  };

  const guardarPublicaciones = async () => {
    try {
      let data = await apiJurados.guardarInformarcionjuradospublicaciones(idJurado, publicaciones);
      let { mostrarNotificacion } = Notificaciones({
        titulo: "Proceso completado",
        descripcion: "Las publicaciones fueron guardadas",
        placement: "bottomRight",
      });
      mostrarNotificacion();
      return data;
    } catch (error) {
      return console.error(error);
    }
  };

  const [openModal, setOpenModal] = useState(false);

  const continuarPublicaciones = async () => {
    try {
      await apiJurados.guardarInformarcionjuradospublicaciones(idJurado, publicaciones);
      
      if(estadoFormulario != '' && estadoFormulario != undefined){
        dispatch(juradoEditar(false))
        return navigate('/usuario/estadosFormulario')
      }

      if (menuJurado){
        dispatch(menuJuradoAction(false));
        return navigate("/usuario/MenuJurado");
      }

      return navigate("/usuario/DocumentosAdministrativosJurado");
    } catch (error) {
      return console.error(error);
    }
  };
  return {
    publicacion,
    setPublicacion,
    publicaciones,
    setPublicaciones,
    modaleditar,
    setModaleditar,
    modaleliminar,
    setModaleliminar,
    indexpublicacion,
    setIndexpublicacion,
    fileInputRef,
    agregarFila,
    limpiarCampos,
    guardarCamposModal,
    guardarArchivo,
    guardarArchivoeditar,
    eliminarFila,
    nombrepublicacion,
    setNombrepublicacion,
    guardarPublicaciones,
    continuarPublicaciones,
    modalvisualizardocumento: modalVisualizarDocumento,
    setModalVisualizarDocumento,
    documentovisualizar: documentoVisualizar,
    setDocumentoVisualizar,
    prevScreen,
    openModal, 
    setOpenModal
  };
};
